import { NotificationsNone } from "@mui/icons-material";
import { Badge, Box, IconButton } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { APIRoutes } from "../../../constants";
import { HOSTURL_LOCAL, RequestServer } from "../../../utils/services";
import NotificationsList from "./NotificationsList";
import { useSnackbar } from "notistack";
import { getUserId } from "../../../utils/role";
import { useOnlineStatus } from "../../../utils/hooks/useOnlineStatus";

export default function Notifications() {
  const [data, setData] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { enqueueSnackbar } = useSnackbar();
  const [readNotifications, setReadNotifications] = useState<any>([]);
  const [unreadNotifications, setUnreadNotifications] = useState<any>([]);
  const online = useOnlineStatus();


  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const fetchData = async () => {
    const url = APIRoutes.NOTIFICATIONS + "?limit=100" + "&sort_by=desc___created_at"
    const response = await RequestServer(url, "GET");
    const response_data: Array<any> = response.data || [];
    
    if (response_data) {
      setData(response_data);
      const unread_notifications = response_data.filter((notification: any) => notification && !notification.read_on);
      const read_notifications = response_data.filter((notification: any) => notification && notification.read_on);
      const unread_notifications_len = unread_notifications.length;
      const local_unread_notifications_len = localStorage.getItem("unread_notifications");
      
      if(local_unread_notifications_len && (+local_unread_notifications_len < unread_notifications_len)) {
        enqueueSnackbar("New Notification Received", { variant: "success" });
      }

      localStorage.setItem("unread_notifications", String(unread_notifications_len));
      setReadNotifications(read_notifications);
      setUnreadNotifications(unread_notifications);
    }
  }

  // ⚡ Call fetchData on mount and every 3 mins
  useEffect(() => {
    if (online) {
      fetchData(); // initial call
    }

    const interval = setInterval(() => {
      if (online) {
        fetchData();
      }
    }, 180000); // 3 minutes = 180000 ms

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  // This below code is disabled for now, this is related to server side events. Date - 21 May 2025
  if(0) {
    useEffect(() => {
      let eventsource: EventSource | null = null;
      let reconnectFrequencySeconds = 1;
      let reconnectAttempts = 0;
      const maxReconnectAttempts = 2;

      const reconnect = () => {
        if (reconnectAttempts >= maxReconnectAttempts) {
          console.error("Maximum reconnection attempts reached. Closing EventSource.");
          return;
        }
        reconnectAttempts++;
        reconnectFrequencySeconds = Math.min(reconnectFrequencySeconds * 2, 30);
        setTimeout(() => {
          setupEventSource();
        }, reconnectFrequencySeconds * 1000);
      };

      const setupEventSource = () => {
        eventsource = new EventSource(
          HOSTURL_LOCAL + APIRoutes.NOTIFICATIONS + "/events?user_id=" + getUserId(),
        );
        eventsource.addEventListener("connected", fetchData);
        eventsource.addEventListener("notification received", async () => {
          enqueueSnackbar("New Notification Received", {
            variant: "success"
          })
          await fetchData()
        });
        eventsource.onerror = () => {
          console.error("EventSource failed.");
          eventsource?.close();
          reconnect();
        };
      };

      setupEventSource();

      return () => {
        eventsource?.close(); // 🔥 clean up on unmount
      };
    }, []);
  }
  return (
    <Box sx={{ position: "relative" }}>
      <IconButton
        id="notifications-button"
        onClick={handleClick}
        color="inherit"
        aria-label="open drawer"
        edge="start"
        disableRipple
        sx={{ marginX: "auto" }}
      >
        <Badge
          badgeContent={
            data.filter((notification: any) => !notification.read_on).length
          }
          color="error"
        >
          <NotificationsNone />
        </Badge>
      </IconButton>
      <NotificationsList
        open={open}
        anchorEl={anchorEl}
        handleClose={handleClose}
        data={data}
        setData={setData}
        readNotifications={readNotifications}
        unreadNotifications={unreadNotifications}
        fetchData={fetchData}
      />
    </Box>
  );
}